/* app/js/src/components/autopilot/graphicsRuleWizard/step1/substep2.scss */
.cursor-pointer {
  cursor: pointer;
}
.drag-area {
  width: 260px;
  height: 195px;
  border: dashed 1px #c6d2df;
  position: relative;
  cursor: pointer;
  background-position: center;
  background-size: contain;
}
.drag-area .drag-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 13px;
  color: #c6d2df;
  text-align: center;
  pointer-events: none;
}
.drag-area .drag-text .plus-sign {
  width: 35px;
  height: 35px;
  margin-left: auto;
  margin-right: auto;
}
.drag-area .drag-text .plus-sign ::ng-deep svg path {
  fill: #c6d2df;
}
.drag-area .trash {
  background-image: url(/assets/icons/pop-trash.svg);
  width: 19px;
  height: 18px;
  position: absolute;
  right: -41px;
  bottom: 0;
  display: none;
}
.drag-area:hover,
.drag-area.on-drag {
  border-color: #a65bfa;
}
.drag-area:hover .drag-text,
.drag-area.on-drag .drag-text {
  color: #a65bfa;
}
.drag-area:hover .plus-sign ::ng-deep svg path,
.drag-area.on-drag .plus-sign ::ng-deep svg path {
  fill: #a65bfa !important;
}
.drag-area.has-item {
  border-color: transparent;
  background-size: cover;
  background-position: center center;
}
.drag-area.has-item .drag-text {
  display: none;
}
.drag-area.has-item .trash {
  display: block;
}
label {
  display: block;
  color: #879baf;
  font-size: 20px;
  max-width: 260px;
  margin-top: 20px;
}
/*# sourceMappingURL=substep2.css.map */
